import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CustomDateRange from "../customDateRange/CustomDateRange";
import { getAutoSummaryDetails, getAutoTradeDetails, getFundDetails, getUserSymbols, getUserPrivilege, insertHedgeTradeDetails, updateExecutedTradeDetails, updateInitialBalanceDetails } from "../../api/otherEndPoints/backOffice";
import { useSelector } from "react-redux";
import './style.css';
import csvDownload from "json-to-csv-export";
import moment from 'moment';
import React from "react";
import { getUserMail } from "../../services/util/getUserMail";
import Cookies from "js-cookie";
import { InputText } from "primereact/inputtext";
import FadeLoader from "react-spinners/FadeLoader";
import { getModelWiseParams } from "../../services/util/backdatedParams";
import { Slide, toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from 'primereact/dropdown';


const BackofficeAdvice = () => {

    const [backStartDate, setBackStartDate] = useState<any>('2025-02-05')
    const [backEndDate, setBackEndDate] = useState<any>(moment().format("YYYY-MM-DD"))

    const [backVersion, setBackVersion] = useState<any>('equity')
    const [summaryDetails, setSummaryDetails] = useState<any>([])
    const [autoTradeDetails, setAutoTradeDetails] = useState<any>([])
    const [livefilter,setLiveFilter] = useState<any>(false)
    const [filterTradeDetails,setFilterTradeDetails] = useState<any>([])
    const [selectedRow, setSelectedRow] = useState<any>(null)
    const [summarySelectedRow, setSummarySelectedRow] = useState<any>(null)
    const [privilege, setPrivileges] = useState<any>()
    const [tradeEdited, setTradeEdited] = useState<any>(true)
    const [fundDetails, setFundDetails] = useState<any>()
    const [executedTradeFilter, setExecutedTradeFilter] = useState<any>(false)
    // const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [symbolError, setSymbolError] = useState("");
    const [editedClosedStatus, setEditedClosedStatus] = useState("Open");
    const [entrytDate, setEntrytDate] = useState(null);
    const [exitDate, setExitDate] = useState(null);
    // const [editedExitDate, setEditedExitDate] = useState(null);

    const [formData, setFormData] = useState<any>({
        OpenDate: '',
        CloseDate: '',
        Quantity: "",
        TradeType: "long",
        EntryPrice:"",
        ExitPrice: "",
        Symbol: "",
        Status: "",
        EntryTime: "",
        ExitTime: "", 
        User: getUserMail(),
    });
    const [symbols, setSymbols] = useState([])

    const validateSymbolEntryForHedge = (value?: string) => {
        if (!value) return; // Prevent running on undefined values
        if (value.length > 10 && value.startsWith("NIFTY")) {
            const symbolPattern = /^NIFTY\d{2}[A-Z]{3}\d{2}\d+(C|P)E$/;
            setSymbolError(symbolPattern.test(value) ? "" : "Invalid format. Example: NIFTY24JAN2015500CE");
        }
    };
    const handleChange = (e:any, field:any) => {
        let value = e?.target?.value;
        if (field == 'OpenDate' || field == 'CloseDate'){
            value = value?.toLocaleDateString('en-CA') || ""; 
        }
        if(field === 'Symbol')  value = value.toUpperCase();
        setFormData({ ...formData, [field]: value });
        
    };

    useEffect(() => {
        setSelectedRow(autoTradeDetails[0])
    }, [backStartDate, backEndDate, backVersion])

    useEffect(() => {
        if (loading) {
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }
    }, [loading]);

    useEffect(() => {
        getUserPrivilege(getUserMail()).then((res: any) => {
            if (res) setPrivileges(res)
        })
    }, [backStartDate, backEndDate])


    useEffect(() => {
        const fetchData = async () => {
            try {
                let privileges:any;
                let total_privileges:any = Cookies.get('codesArray')
                if (backVersion === 'all'){
                    privileges = total_privileges
                }
                else if (backVersion === 'equity'){
                    total_privileges = JSON.parse(total_privileges)
                    
                    privileges = total_privileges?.filter((code:any) =>
                        code.startsWith('AES') || code.startsWith('QES') || code.startsWith('QEB')
                    );
                    privileges = JSON.stringify(privileges)
                }
                else if (backVersion === 'fno'){

                    total_privileges = JSON.parse(total_privileges)
                    privileges = total_privileges?.filter((code:any) =>
                        code.startsWith('AIO') || code.startsWith('QIO') 
                    );
                    privileges = JSON.stringify(privileges)
                }
                else{
                    privileges = backVersion
                } 
                
                setAutoTradeDetails([]);
                setSummaryDetails([]);
    
                const [summaryDetailsRes, fundDetailsRes, autoTradeDetailsRes] = await Promise.all([
                    getAutoSummaryDetails(backStartDate, backEndDate, privileges, getUserMail()),
                    getFundDetails(backStartDate, backEndDate, getUserMail()),
                    getAutoTradeDetails(backStartDate, backEndDate, privileges, getUserMail())
                ]);
    
                if (summaryDetailsRes) setSummaryDetails(summaryDetailsRes);
                if (fundDetailsRes) setFundDetails(fundDetailsRes);
                if (autoTradeDetailsRes) setAutoTradeDetails(autoTradeDetailsRes);
    
            } 
            catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();
    }, [backStartDate, backEndDate, backVersion, tradeEdited]);
    
    useEffect(() => {

        getUserSymbols(getUserMail()).then((res: any) => {

            if (res){ 
                setSymbols(res)
            }

        })

        

    }, [isModalVisible])

    useEffect(() => {
        const filteredData = autoTradeDetails.filter((item:any) => {
            if (executedTradeFilter && livefilter) return item.b_traded && (!item.s_fs_status || item.s_fs_status === "");
            if (executedTradeFilter) return item.b_traded;
            if (livefilter) return !item.s_fs_status || item.s_fs_status === "";
            return true;
            });
            setFilterTradeDetails(filteredData);
        }, [autoTradeDetails, executedTradeFilter, livefilter]);

    const theme: any = useSelector((state: any) => {
            return state.theme.isTheme;
    });

    const getFontColorAsPerValue = (value: number | null) => {
        if (value === null) return "";
        return value >= 0 ? (theme === "dark" ? "lightgreen" : "#338f33") : "orangered";
      };

    const handlevalue = (value: any) => {
        if (value === '' || value === undefined || value === null) return ''
        else return <span style={{ color: getFontColorAsPerValue(value), fontWeight: '600' }}>{value?.toFixed(2)}</span>
    };

    const getPlInRupees = (value: any) => {
        if (value === '' || value === undefined || value === null) return ''
        const rupeeSymbol = value < 0 ? "-₹" : "₹";
        const color = getFontColorAsPerValue(value);
        const formattedValue = `${rupeeSymbol}${Math.abs(value).toFixed(2)}`;
        return <span style={{ color, fontWeight: '600' }}>{formattedValue}</span>;
    };
    
    const getReturnWithPercentageSymbol = (value: any) => {
        if (value === '' || value === undefined || value === null) return ''
        else return <span style={{ color: getFontColorAsPerValue(value), fontWeight: '600' }}>{'('+String(value?.toFixed(2)) + '%)'}</span>
    };

    const getReturnWithPercentageSymbolHover = (value: any) => {
       return value === null || value === undefined || value === '' ? '' : `${String(value?.toFixed(4))}%`;
    };
 
    const fourDecimalPlacesWithComma = (value: any) =>{
       return value === null || value === undefined || value === '' ? '' : `${value.toFixed(4)},`;
    };

    const processColumnNames = (data: object[]): string[] => {
        if (!data || data.length === 0) return []; 
    
        return Object.keys(data[0])
            .filter(column => {
                const lowerColumn = column.toLowerCase();
                return lowerColumn !== "code" && lowerColumn !== "n_id"; 
            })
            .map(column => {
                return column
                    .replace(/_/g, " ")                // Replace underscores with spaces
                    .replace(/in rs/gi, "(₹)")        // Replace "in rs" with "(₹)"
                    .replace(/(?:^|\s)s\s/gi, "")     // Remove isolated "s " at the start or middle of strings
                    .replace(/model/gi, "FS")         // Replace "model" with "FS"
                    .replace(/\b(dt|n)\b\s?/gi, "") // Remove standalone "Pl", "Dt", and "N"
                    .split(" ")                      // Split into words
                    .map(word => 
                        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize each word
                    )
                    .join(" ")                       // Join words back into a single string
                    .replace(/\b(Fs)\b/gi, "FS")    // Standardize "FS" capitalization
                    .replace(/\b(Pl)\b/gi, "PL");    // Standardize "PL" capitalization

            });
    };
    
    const replaceNullWithEmptyString = (obj: any) => {
                                                        Object.keys(obj).forEach(key => {
                                                            if (obj[key] === null) {
                                                            obj[key] = '';
                                                            } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                                                            replaceNullWithEmptyString(obj[key]);
                                                            }
                                                        });
                                                        };
      
    const csvDataMaker = (data:any, filename:any) => {
        const downloadable_summary_details = data.map((item:any) => {
            const { code, Code, n_id, ...rest } = item; 

            replaceNullWithEmptyString(rest);
            return rest; 
          });  

        const summaryDetailsColumnNames = processColumnNames(downloadable_summary_details);

        const summarydDataToConvert = {
            data: downloadable_summary_details,
            filename: `${filename} ${(new Date()).toLocaleString()}`,
            delimiter: ",",
            headers: summaryDetailsColumnNames
        }
        csvDownload(summarydDataToConvert);
    };

    const columnHeader = (str1: any, str2: any, str3: any) => {
        return (
            <div  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontWeight:"500 !important" }}>
                {str1 !== "" ? <div >{str1}</div> : <div></div>}
                <div>{str2}</div>
                {str3 !== "" ? <div style= {{fontSize:'0.8rem', fontWeight:"400"}} >({str3})</div> : <br></br>}
            </div>
        )
    };
   
    const renderPLAndReturn = (
        rowData: any,
        plField: string,
        returnField: string
    ) => {
        return (
            <>
                <div
                    style={{
                        color: getFontColorAsPerValue(rowData[plField]),
                    }}
                    className="hovertextdiv hoverd"
                    data-hover={fourDecimalPlacesWithComma(rowData[plField])}
                >
                    {handlevalue(rowData[plField])}
                    {rowData["executed_lots"] !== 1 && rowData[plField] !== null && (
                        <>
                            ,&nbsp;&nbsp;&nbsp;
                            {getPlInRupees(rowData[`${plField}_in_rs`])}
                        </>
                    )}
                </div>
                <div
                    style={{
                        color: getFontColorAsPerValue(rowData[returnField]),
                        width: "100%", fontSize:'0.8rem'
                    }}
                    className="hovertextdiv hoverd"
                    data-hover={getReturnWithPercentageSymbolHover(rowData[returnField])}
                >
                    {getReturnWithPercentageSymbol(rowData[returnField])}
                </div>
            </>
        );
    };
    
    const changeValueToTwoDecimal = (value:any) => {
        if (value === '' || value === undefined || value === null) {
            return ''
        }
        else {
            return Number(value)?.toFixed(2)
        }
    };
    
    const activeTrade = (item: any) => {
        if ((item?.s_fs_status === null || item?.s_fs_status === '' || item?.s_fs_status === 'Open') && (item?.auto_trade_status === 'close')){
            return 'FSopenTrade'
        }
        else if ((item?.s_fs_status === null || item?.s_fs_status === '' || item?.s_fs_status === 'Open') && (item?.auto_trade_status === 'open')){
            return 'openTrade'
        }
        else if ((item?.s_fs_status !== null || item?.s_fs_status !== '' || item?.s_fs_status !== 'Open') && (item?.auto_trade_status === 'open')){
            return 'FScloseTrade'
        }
    };
   
    const HandleDate = (date:any) =>{
        if(date === '') return ''
        return moment(date).format("DD MMM YYYY")
    };

    // const loader = () => {
    //     setLoading(!loading);
    //     setTimeout(() => {
    //     setTradeEdited(!tradeEdited)
    //       setLoading(!loading);
    //       setShow(!show);
    //     }, 300);
    // };
      
    const updateTradeDetails = (data_to_be_updated:any) => {
        // loader()
        let data = data_to_be_updated['newData']
        data['closedStatus'] = editedClosedStatus
        console.log("e.target.value data", data)
        updateExecutedTradeDetails(data_to_be_updated['newData']).then((res: any) => {
            notify(res)
            setTradeEdited(!tradeEdited)
        })
    };

    const updateInitialBalance = (data_to_be_updated:any) => {
        // loader()
        updateInitialBalanceDetails(data_to_be_updated['newData']).then((res: any) => {
            console.log(res)
            setTradeEdited(!tradeEdited)
        })
    };

    const textEditor = (options:any, columnName:any) => {
        return <InputText 
                    type="text"      
                    className=" w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={options?.rowData[columnName]} 
                    onChange={(e:any) => options.editorCallback(e.target.value)} />;
    };
  
    const closeReasonDropDown = (options:any, columnName:any) => {
            return  <select
                            style={{ background: 'rgba(240, 240, 240, 0.8)', borderRadius: '0.2rem', width: '5rem' }}
                            defaultValue={options?.rowData[columnName] || 'Open'} 
                            onChange={(e: any) => {
                                options.editorCallback(e.target.value);
                                setEditedClosedStatus(e.target.value);
                            }}
                        >
                            <option style={{ fontWeight: '700' }} value={options?.rowData[columnName] || 'Open'}>
                                {options?.rowData[columnName] || 'Open'}
                            </option>

                            <option style={{ fontWeight: '700' }} value="Others">
                                Closed
                            </option>
                        </select>
    };

    const notify = (data: any) => {
        if (data.status === true) {
            toast.success(data.message, {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Slide,
            });
        } else if (data.status === false)  {
            toast.error(data.message || "An error occurred", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Slide,
            });
        }
    };
    

    
    return (
        <>
        {loading
        ?
        <div className="loaderPosition">
            <FadeLoader color='orange' />
        </div>
        :
        <div>
            <div style={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "0 0 0.5rem 0" }} >
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <b className="backoffice_daterange_text backoffice_title mr-2">Date Range</b>
                        <CustomDateRange 
                            backStartDate={backStartDate} 
                            setBackStartDate={setBackStartDate} 
                            backEndDate={backEndDate} 
                            setBackEndDate={setBackEndDate} 
                        />
                    </div>

                    <div style={{ display: "flex", alignItems: "center", marginLeft: "2rem" }}>
                        <b className="backoffice_daterange_text backoffice_title">Model</b>
                        <select 
                            className="selectBackofficeVersion" 
                            id="select_version" 
                            onChange={(e) => setBackVersion(e.target.value)}
                            style={{ marginLeft: "0.75rem", padding: "6px 12px", borderRadius: "6px", border: "1px solid #ccc", background: "#f8f9fa", cursor: "pointer" }}
                        >
                            <option style ={{fontWeight:'700'}} value="all">All</option>
                            <option style ={{fontWeight:'700'}} value="equity" selected>CASH</option>
                            <option style ={{fontWeight:'700'}} value="fno">FNO</option>
                            <option style ={{fontWeight:'700'}} value="[HEDGE]">HEDGE</option>

                            {privilege?.map((item: any) => {
                                const modelParam = getModelWiseParams(item['s_code']);
                                // console.log("privilege mapping, Before ->", item['s_code'], "after -> ", modelParam === ' ' ? item['s_symbol'] : modelParam )
                                return (
                                    <option key={item['s_code']} className="total_symbol" value={`[${item['s_code']}]`}>
                                        {modelParam === ' ' ? item['s_symbol'] : modelParam}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <Button className="add_hedge_transaction_button" icon = "pi pi-plus" label="Add Transactions" onClick={() => setIsModalVisible(true)} />
                <Dialog header={
                            <div style={{
                                fontSize: '1.1rem', 
                                fontWeight: 'bold', 
                                textAlign: 'center',
                                padding: '0rem',
                                borderBottom: '1px solid #grey',
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                borderTopLeftRadius: '10px',
                                borderTopRightRadius: '10px'
                            }}>
                                Add a Transaction
                            </div>
                        }
                        visible={isModalVisible} 
                        style={{ width: '50%', backgroundColor: 'transparent', boxShadow: 'none', padding:'0.4rem!important' }} 
                        contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', backdropFilter: 'blur(10px)', borderRadius: '10px' }}
                        onHide={() => setIsModalVisible(false)}>
                    
                    <div className="p-grid p-fluid" >
                        <div className="p-col-6" style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between' }}>
                            {/* Entry Date */}
                            <div style={{ width: '48%' }}>
                                <label style={{ fontWeight: '700' }}>Entry Date</label>
                                <Calendar 
                                    className="add_hedge_calendar" 
                                    value={entrytDate} 
                                    onChange={(e: any) => {handleChange(e, 'OpenDate');setEntrytDate(e?.target?.value)}} 
                                    dateFormat="dd/mm/yy"
                                    showIcon 
                                />
                            </div>
                            {/* Exit Date */}
                            <div style={{ width: '48%' }}>
                                <label style={{ fontWeight: '700' }}>Exit Date</label>
                                <Calendar 
                                    className="add_hedge_calendar" 
                                    value={exitDate} 
                                    onChange={(e: any) => {handleChange(e, 'CloseDate');setExitDate(e?.target?.value)}} 
                                    dateFormat="dd/mm/yy"
                                    showIcon 
                                />
                            </div>
                        </div>

                        
                        <div className="p-col-12" style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                                    {/* Entry Time */}
                                    <div style={{ flex: 1 }}>
                                        <label style={{ fontWeight: '700' }}>Entry Time  (HH:MM:SS format)</label>
                                        <input 
                                            className="add_hedge_timepicker"
                                            value={formData.EntryTime} 
                                            onChange={(e) => setFormData({ ...formData, ['EntryTime']: e.target.value })} 
                                            type="text"
                                            placeholder="HH:MM:SS"
                                            style={{ width: '100%', padding: '0.5rem', borderRadius: '6px', border: '1px solid #ccc' }}
                                        />

                                    </div>
                                    {/* Exit Time */}
                                    <div style={{ flex: 1 }}>
                                        <label style={{ fontWeight: '700' }}>Exit Time (HH:MM:SS format)</label>
                                        <input 
                                            className="add_hedge_timepicker"
                                            value={formData.ExitTime} 
                                            onChange={(e) => setFormData({ ...formData, ['ExitTime']: e.target.value })} 
                                            type="text"
                                            placeholder="HH:MM:SS"
                                            style={{ width: '100%', padding: '0.5rem', borderRadius: '6px', border: '1px solid #ccc' }}
                                        />
                                    </div>
                                </div>


                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                            {/* Entry Price */}
                            <div >
                                <label style ={{fontWeight:'700'}}>Entry Price</label>
                                <InputText value={formData['EntryPrice']} type = "number" onChange={(e:any) => handleChange(e, 'EntryPrice')} />
                            </div>
                            {/* Exit Price */}
                            <div >
                                <label style ={{fontWeight:'700'}}>Exit Price</label>
                                <InputText value={formData['ExitPrice']} type = "number" onChange={(e:any) => handleChange(e, 'ExitPrice')} />
                            </div>
                            {/* Quantity */}
                            <div>
                                <label style={{ fontWeight: '700' }}>Quantity</label>
                                <InputText 
                                    value={formData['Quantity']} 
                                    type="number" 
                                    onChange={(e: any) => handleChange(e, 'Quantity')} 
                                    className="w-full"
                                />
                            </div>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                            {/* Symbol */}
                            <div>
                                <label style={{ fontWeight: '700' }}>Symbol</label>
                                {/*<InputText
                                    className="w-full add_symbol-placeholder"
                                    placeholder="Ex: NIFTY25JAN3115500CE"
                                    value={formData['Symbol']}
                                    onChange={(e: any) => handleChange(e, 'Symbol')}
                                    onBlur={(e: any) => validateSymbolEntryForHedge(e.target.value)}
                                />
                                {symbolError && <small style={{ color: 'red' }}>{symbolError}</small>}*/}

                                <Dropdown value={formData['Symbol']} 
                                            onChange={(e: any) => {handleChange(e, 'Symbol');}}
                                            options={symbols} 
                                            onBlur={(e: any) => validateSymbolEntryForHedge(e.target.value)}
                                            editable 
                                            
                                            placeholder="Option Symbol format: NIFTY25JAN3115500CE" 
                                            />
                            </div>
                            {symbolError && <small style={{ color: 'red' }}>{symbolError}</small>}
                            {/* Trade Type */}
                            <div >
                                <label style ={{fontWeight:'700'}}>Trade Type</label>
                                <select 
                                        style={{ background: 'rgba(240, 240, 240, 0.8)', borderRadius: '0.2rem', width: '100%', padding:'0.8rem' }}  
                                        value={formData?.TradeType || ""}
                                        onChange={(e:any) => handleChange(e, 'TradeType')} 
                                >
                                    <option style ={{fontWeight:'700'}}  value="long">Long</option>
                                    <option style ={{fontWeight:'700'}}  value="short">Short</option>
                                </select>
                            </div>
                            {/* Status */}
                            <div >
                                <label style={{ fontWeight: '700' }}>Status</label>
                                <select 
                                    style={{ background: 'rgba(240, 240, 240, 0.8)', borderRadius: '0.2rem', width: '100%', padding:'0.8rem'  }} 
                                    value={formData['Status']} 
                                    onChange={(e: any) => handleChange(e, 'Status')}
                                >
                                    <option style={{ fontWeight: '700' }} value="">Open</option>
                                    <option style={{ fontWeight: '700' }} value="Others">Closed</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div style={{marginTop: '1rem'}}>
                        <Button 
                            icon="pi pi-trash" 
                            style={{background:"black", color:'white'}} 
                            onClick={() => setIsModalVisible(false)} 
                            />
                        <Button 
                            icon="pi pi-check" 
                            style={{background:"black", color:'white'}} 
                            onClick={() => {
                                            setIsModalVisible(false);
                                            insertHedgeTradeDetails(formData);
                                            setTradeEdited(!tradeEdited)
                                            // loader();
                                        }} 
                            />
                    </div>
                </Dialog>
            </div>

            {/*FUND SUMMARY*/}
            <div style={{
                    backgroundColor: 'rgba(240, 240, 240, 0.2)', 
                    borderRadius: '10px', 
                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                    marginBottom:'1rem'
                }}>
                <div className="title_heading">
                    <span >Fund Summary</span>
                </div>
                {/* <div style={{padding:"0% 20%",display: 'flex', justifyContent: 'space-between', width: '100%', fontSize:"1.1rem", fontWeight:"700"}}>
                    <span>FS</span>
                    <span>Executed</span>
                </div> */}

                <DataTable 
                    value={fundDetails} 
                    className="summary_table d-flex justify-content-between align-items-center" 
                    editMode="row" 
                    scrollable
                    onRowEditComplete={updateInitialBalance}>
                        
                    <Column 
                        rowEditor 
                        frozen 
                        alignFrozen="left"
                    />
                    
                    <Column header = {columnHeader("", "Opening Balance", "FS")}
                            field="initial_balance"
                            // bodyStyle={{textAlign: 'center'}}
                            editor={(options) => textEditor(options, "initial_balance")}
                            body={(e) => 
                                <>
                                    <div 
                                        style={{  minWidth: '7rem', fontWeight: '500' }}
                                        title={`Opening Balance as on ${e['account_open_date']}: ₹${e['initial_balance']?.toFixed(2)}`}
                                    >
                                        {'₹' + e['fs_opening_balance']?.toFixed(2)}
                                    </div>
                                    <div 
                                        style={{  minWidth: '7rem', fontSize: '0.8rem' }}
                                        title={`Percentage: 100%`}
                                    >
                                        ({'100%'})
                                    </div>
                                </>
                    } />
                    
                    <Column header = {columnHeader("Gross P/L", "with Hedge", "FS")} 
                            body={(e) => <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {getPlInRupees(e['fs_pl_in_rs'])}
                                            </div>
                                            <div style={{  minWidth: '7rem', fontSize: '0.8rem' }}>
                                                {(e['fs_pl_in_rs_perc']?'('+e['fs_pl_in_rs_perc']?.toFixed(2)+'%)':'')}
                                            </div>
                                            </>
                    } />
                                                    
                    <Column header = {columnHeader("Net P/L", "with Hedge", "FS")} 
                            body={(e) => 
                                        <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {getPlInRupees(e['fs_pl_after_cost_in_rs'])}
                                            </div>
                                            <div style={{  minWidth: '7rem', fontSize: '0.8rem' }}>
                                                {(e['fs_pl_after_cost_in_rs_perc']?'('+e['fs_pl_after_cost_in_rs_perc']?.toFixed(2)+'%)':'')}
                                            </div>
                                        </>
                    } />

                    <Column header = {columnHeader("", "Cost", "FS")} 
                            body={(e) => 
                                        <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {e['fs_regulatory_cost_in_rs']?'₹'+e['fs_regulatory_cost_in_rs']?.toFixed(2):''}
                                            </div>
                                            <div style={{  minWidth: '7rem', fontSize: '0.8rem' }}>
                                                {(e['fs_regulatory_cost_in_rs_perc']?'('+e['fs_regulatory_cost_in_rs_perc']?.toFixed(2)+'%)':'')}
                                            </div>
                                        </>
                    } />

                <Column header = {columnHeader("Gross P/L", "without Hedge", "FS")} 
                            body={(e) => <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {getPlInRupees(e['fs_pl_without_hedge'])}
                                            </div>
                                            </>
                    } />
{/* 
                    <Column header = {columnHeader("", "Remaining Balance", "FS")}  
                            body={(e) => 
                                        <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {e['fs_remaining_balance']?'₹'+e['fs_remaining_balance']?.toFixed(2):''}
                                            </div>
                                            <div style={{  minWidth: '7rem', fontSize: '0.8rem' }}>
                                                {(e['fs_remaining_balance_in_perc']?'('+e['fs_remaining_balance_in_perc']?.toFixed(2)+'%)':'')}
                                            </div>
                                        </>
                    } /> */}

                   

                    <Column header = {columnHeader("Gross P/L", "Only Hedge", "FS/Executed")} 
                            body={(e) => <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {getPlInRupees(e['hedge_pl'])}
                                            </div>
                                            </>
                    } />

                    <Column header = {columnHeader("", "Opening Balance", "Executed")}
                            field="initial_balance"
                            bodyStyle={{textAlign: 'center'}}
                            // editor={(options) => textEditor(options, "initial_balance")}
                            body={(e) => 
                                <>
                                    <div 
                                        style={{  minWidth: '7rem', fontWeight: '500' }}
                                        title={`Opening Balance as on ${e['account_open_date']}: ₹${e['initial_balance']?.toFixed(2)}`}
                                    >
                                        {'₹' + e['trade_opening_balance']?.toFixed(2)}
                                    </div>
                                    <div 
                                        style={{  minWidth: '7rem', fontSize: '0.8rem' }}
                                        title={`Percentage: 100%`}
                                    >
                                        ({'100%'})
                                    </div>
                                </>
                    } />
                    
                    <Column header = {columnHeader("Gross PL", "with Hedge", "Executed")} 
                            body={(e) => <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {getPlInRupees(e['trade_pl_in_rs'])}
                                            </div>
                                            <div style={{  minWidth: '7rem', fontSize: '0.8rem' }}>
                                                {(e['trade_pl_in_rs_perc']?'('+e['trade_pl_in_rs_perc']?.toFixed(2)+'%)':'')}
                                            </div>
                                            </>
                    } />
                                                    
                    <Column header = {columnHeader("Net P/L", "with Hedge", "Executed")} 
                            body={(e) => 
                                        <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {getPlInRupees(e['trade_pl_after_cost_in_rs'])}
                                            </div>
                                            <div style={{  minWidth: '7rem', fontSize: '0.8rem' }}>
                                                {(e['trade_pl_after_cost_in_rs_perc']?'('+e['trade_pl_after_cost_in_rs_perc']?.toFixed(2)+'%)':'')}
                                            </div>
                                        </>
                    } />
                    
                    <Column header = {columnHeader("", "Cost", "Executed")}
                            body={(e) => <>
                                            <div style={{  minWidth: '7rem', fontWeight: '500' }}>
                                                {e['trade_regulatory_cost_in_rs']?'₹'+e['trade_regulatory_cost_in_rs']?.toFixed(2):''}
                                            </div>
                                            <div style={{  minWidth: '7rem', fontSize: '0.8rem' }}>
                                                {(e['trade_regulatory_cost_in_rs_perc']?'('+e['trade_regulatory_cost_in_rs_perc']?.toFixed(2)+'%)':'')}
                                            </div>
                                        </>
                    } />


                    <Column header = {columnHeader("Gross P/L", "without Hedge", "Executed")} 
                            body={(e) => <>
                                            <div style={{  minWidth: '8rem', fontWeight: '500' }}>
                                                {getPlInRupees(e['pl_without_hedge'])}
                                            </div>
                                            </>
                    } />

                    {/* <Column header = {columnHeader("", "Remaining Balance", "Executed")}  
                            body={(e) => 
                                        <>
                                            <div style={{  minWidth: '10rem', fontWeight: '500' }}>
                                                {e['trade_remaining_balance']?'₹'+e['trade_remaining_balance']?.toFixed(2):''}
                                            </div>
                                            <div style={{  minWidth: '10rem', fontSize: '0.8rem' }}>
                                                {(e['trade_remaining_balance_in_perc']?'('+e['trade_remaining_balance_in_perc']?.toFixed(2)+'%)':'')}
                                            </div>
                                        </>
                    } />
                     */}
                </DataTable>



                
            </div>
            
            {/*TRADE SUMMARY*/}
            <div style={{
                    backgroundColor: 'rgba(240, 240, 240, 0.2)', 
                    borderRadius: '10px', 
                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                    marginBottom:'1rem'
                }}>

                <div className="title_heading back_office_download d-flex justify-content-between align-items-center ">
                    <span >Trade Summary</span>
                    <div className="table_options">
                            <button
                                className="btn btn-sm btn-neutral mr-2 animated-btn download-btn"
                                onClick={() => csvDataMaker(summaryDetails, 'Summary Details')}
                            >
                                <i className="pi pi-download"></i> 
                            </button>
                        </div>
                </div>        
                
                
                <div className="datatable_div backoffice_summary_datatable" >
                    <DataTable
                        className="summary_table"
                        value={summaryDetails}
                        id="selected_row"
                        scrollable
                        selectionMode="single"
                        selection={
                            summarySelectedRow == null
                                ? summaryDetails[0]
                                : summarySelectedRow
                        }
                        onSelectionChange={(e: any) => setSummarySelectedRow(e.value)}
                        dataKey="uniqueId"
                        resizableColumns
                        removableSort
                    >
                        {/* Symbol/Quantity Column */}
                        <Column
                            header="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  Symbol/Quantity"
                            field="symbol"
                            frozen
                            sortable

                            bodyStyle={{
                                textAlign: "center",
                                minWidth: "6rem",
                            }}
                            body={(e: any) => (
                                <>
                                    <div style={{width: "100%", fontWeight: "500"}}>
                                        {e["symbol"]} - {e["executed_lots"]}
                                    </div>
                                    <div style={{width: "100%", fontSize: "0.75rem" }}>
                                        ({e["product_wise_code"]})
                                    </div>
                                </>
                            )}
                        />
        
                        <Column
                            field="no_of_executed_trades"
                            header={columnHeader("", "Trades", "Executed")}
                            style={{ minWidth: "5rem" }}
                        />
        
                        <Column
                            header={columnHeader("", "PL Before Cost", "FS")}
                            style={{ minWidth: "5rem" }}
                            body={(e: any) =>
                                renderPLAndReturn(
                                    e,
                                    "model_pl",
                                    "model_return"
                                )
                            }
                        />

                        <Column
                            header={columnHeader("", "PL Before Cost", "FS Executed")}
                            style={{ minWidth: "5rem" }}
                            body={(e: any) =>
                                renderPLAndReturn(
                                    e,
                                    "executed_trade_pl_in_model",
                                    "executed_trade_return_in_model"
                                )
                            }
                        />

                        <Column
                            header={columnHeader("", "PL Before Cost", "Executed")}
                            style={{ minWidth: "5rem" }}
                            body={(e: any) =>
                                renderPLAndReturn(
                                    e,
                                    "executed_trade_pl",
                                    "executed_trade_return"
                                )
                            }
                        />
        
                        <Column
                            header={columnHeader("", "PL After Cost", "FS")}
                            style={{ minWidth: "5rem" }}
                            body={(e: any) =>
                                renderPLAndReturn(
                                    e,
                                    "model_pl_after_cost",
                                    "model_return_after_cost"
                                )
                            }
                        />

                        <Column
                            header={columnHeader("", "PL After Cost", "FS Executed")}
                            style={{ minWidth: "5rem" }}
                            body={(e: any) =>
                                renderPLAndReturn(
                                    e,
                                    "executed_trade_pl_after_cost_in_model",
                                    "executed_trade_return_after_cost_in_model"
                                )
                            }
                        />

                        <Column
                            header={columnHeader("", "PL After Cost", "Executed")}
                            style={{ minWidth: "5rem" }}
                            body={(e: any) =>
                                renderPLAndReturn(
                                    e,
                                    "executed_trade_pl_after_cost",
                                    "executed_trade_return_after_cost"
                                )
                            }
                        />
        
                    </DataTable>
                </div>
            </div>

            {/*TRADE DETAILS*/}
            <div style={{
                    backgroundColor: 'rgba(240, 240, 240, 0.2)', 
                    borderRadius: '10px', 
                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                    marginBottom:'1rem'
                }}>

                <div className="title_heading  d-flex justify-content-between align-items-center ">

                    <span >Auto Executed Trade Details {filterTradeDetails?.length !== 0 ? `(${filterTradeDetails?.length})` : ''}</span>
                    
                    <div className="table_options d-flex align-items-center" style={{fontSize:'1rem'}}>
                        <button
                            className={`executed_trade_btn_live ${!executedTradeFilter ? 'live_border' : ""} btn-sm btn-neutral `}
                            onClick={() => { setExecutedTradeFilter((executedTradeFilterFlag: any) => !executedTradeFilterFlag) }}
                        >
                            Executed
                        </button>

                        <button
                            className={`btn_live ${!livefilter ? 'live_border' : ""} btn-sm btn-neutral  live-button-style`}
                            onClick={() => { setLiveFilter((liveFlag: any) => !liveFlag) }}
                        >
                        
                        <title> live</title> Live <span className="stat_live m-0"></span>
                        </button>
                        <button
                            className="btn btn-sm btn-neutral mr-2"
                            onClick={() => csvDataMaker(autoTradeDetails, 'Executed Trade Details')}
                        >
                            <i className="pi pi-download"></i>
                        </button>
                    </div>
                </div>        

                     


                <div className="datatable_div backoffice_summary_datatable autotradeLastchild" style={{ paddingBottom: '2rem' }}>
                    <DataTable
                        value = {filterTradeDetails}
                        id = "selected_row"
                        scrollable
                        selectionMode = "single"
                        selection = {selectedRow ?? filterTradeDetails[0]}
                        onSelectionChange={(e: any) => setSelectedRow(e.value || selectedRow)}
                        dataKey = "n_id"
                        resizableColumns
                        removableSort
                        editMode="row"
                        rowClassName={activeTrade}
                        
                        onRowEditComplete={updateTradeDetails}
                    >
                        <Column
                            rowEditor
                            frozen
                            alignFrozen="left"
                            bodyStyle={{
                                minWidth: '4rem',
                                maxWidth: '4rem',
                                textAlign: 'center',
                                padding: '0rem',
                            }}
                        />

                        <Column
                            header="&nbsp;&nbsp;&nbsp;Symbol/Code"
                            style={{ minWidth: '5rem' }}
                            frozen
                            sortable
                            field = "symbol"
                            bodyStyle={{ textAlign: 'center' }}
                            body={(e: any) => (
                                <>
                                    <div style={{ width: "100%", fontWeight: '500' }}>
                                        {e['symbol']}
                                    </div>
                                    <div style={{ width: "100%", fontSize: '0.75rem' }}>
                                        ({e['product_wise_code']})
                                    </div>
                                </>
                            )}
                        />

                        <Column
                            header={columnHeader("", "Entry Datetime", "FS")}
                            sortable
                            field = "entry_date_time"
                            body={(e: any) => (
                                <>
                                    <div style={{ width: "100%", fontWeight: '500' }}>
                                        {HandleDate(e['entry_date_time'])}
                                    </div>
                                    <div style={{ width: "100%", fontSize: '0.75rem' }}>
                                        ({e['dt_fs_entry_time']})
                                    </div>
                                </>
                            )}
                        />

                        <Column
                            header={columnHeader("", "Entry price", "FS")}
                            body={(e: any) => changeValueToTwoDecimal(e["n_fs_entry_price"])}
                        />

                        <Column
                            field="n_trade_entry_price"
                            header={columnHeader("", "Entry price", "Executed")}
                            editor={(options) => textEditor(options, "n_trade_entry_price")}
                            body={(e: any) => changeValueToTwoDecimal(e["n_trade_entry_price"])}
                        />

                        <Column
                            header={columnHeader("", "Exit Price", "FS")}
                            headerTooltip={"If the trade is still open, then the exit price will be last day's close price"}
                            body={(e: any) => (
                                <>
                                    <div>
                                        {changeValueToTwoDecimal(e["n_fs_exit_price"])}
                                    </div>
                                    <div style={{ fontSize: '0.75rem' }}>
                                        {e["s_fs_status"] 
                                            ? `(${e["s_fs_status"]})` 
                                            : '(Trade is open)'}
                                    </div>
                                </>
                            )}
                        />

                        <Column
                            field="n_trade_exit_price"
                            headerTooltip={"If the trade is still open, then the exit price will be last day's close price"}
                            header={columnHeader("", "Exit Price", "Executed")}
                            editor={(options) => textEditor(options, "n_trade_exit_price")}
                            body={(e: any) => changeValueToTwoDecimal(e["n_trade_exit_price"])}
                        />

                        <Column
                            header={columnHeader("", "Quantity", "")}
                            field="n_quantity"
                            editor={(options) => textEditor(options, "n_quantity")}
                        />

                        {/* Columns for PL Before Cost */}
                        <Column
                            header={columnHeader("", "PL Before Cost", "FS")}
                            style={{ minWidth: '5rem' }}
                            body={(e: any) => renderPLAndReturn(e, "n_fs_pl", "n_fs_return")}
                        />

                        <Column
                            header={columnHeader("", "PL Before Cost", "Executed")}
                            style={{ minWidth: '5rem' }}
                            body={(e: any) => renderPLAndReturn(e, "n_trade_pl", "n_trade_return")}
                        />

                        {/* Columns for PL After Cost */}
                        <Column
                            header={columnHeader("", "PL After Cost", "FS")}
                            style={{ minWidth: '5rem' }}
                            body={(e: any) => renderPLAndReturn(e, "n_fs_pl_after_cost", "n_fs_return_after_cost")}
                        />

                        <Column
                            header={columnHeader("", "PL After Cost", "Executed")}
                            style={{ minWidth: '5rem' }}
                            body={(e: any) => renderPLAndReturn(e, "n_trade_pl_after_cost", "n_trade_return_after_cost")}
                        />
{/* 
                        <Column
                            header={columnHeader("", "Exit Datetime", "FS")}
                            field="exit_date_time"
                            sortable
                            body={(e: any) => (
                                <>
                                    <div style={{ width: "100%", fontWeight: '500' }}>
                                        {HandleDate(e['exit_date_time'])}
                                    </div>
                                    <div style={{ width: "100%", fontSize: '0.75rem' }}>
                                        {e['dt_fs_exit_time']!==''?`(${e['dt_fs_exit_time']})`:''}
                                    </div>
                                </>
                            )}
                        /> */}

                        <Column
                            field="Dividend"
                            headerTooltip={"If the trade received multiple dividends, then the total dividend is displayed."}
                            header={columnHeader("", "Dividend", "")}
                            />

                        
                        <Column
                                field="exit_date_time"
                                header={columnHeader("", "Exit Datetime", "FS")}
                                sortable
                                editor={(options:any) => (
                                    (options.rowData.Code === 'HEDGE' )? 
                                    <Calendar 
                                        value={options.value ? new Date(options.value) : null} 
                                        onChange={(e:any) => options.editorCallback(e.target.value)} 
                                        dateFormat="yy-mm-dd" 
                                    />:''
                                )}
                                body={(e: any) => (
                                    <>
                                        <div style={{ width: "100%", fontWeight: '500' }}>
                                            {HandleDate(e['exit_date_time'])}
                                        </div>
                                        <div style={{ width: "100%", fontSize: '0.75rem' }}>
                                            {e['dt_fs_exit_time'] !== '' ? `(${e['dt_fs_exit_time']})` : ''}
                                        </div>
                                    </>
                                )}
                            />
                        <Column
                            header={columnHeader("", "Status", "FS")}
                            headerTooltip={"Only update the STATUS for HEDGE "}
                            editor={(options) => 
                                (options.rowData.Code === 'HEDGE' && (options.rowData.s_fs_status === '' || options.rowData.s_fs_status?.toLowerCase() === 'open')) 
                                    ? closeReasonDropDown(options, "s_fs_status") 
                                    : (
                                        <div style={{ fontSize: '0.75rem' }}>
                                            {options.rowData.s_fs_status ? `(${options.rowData.s_fs_status})` : ''}
                                        </div>
                                    )
                            }
                            body={(e: any) => (
                                <>
                                    <div style={{ fontSize: '0.75rem' }}>
                                        {e["s_fs_status"] 
                                            ? `(${e["s_fs_status"]})` 
                                            : ''}
                                    </div>
                                </>
                            )}
                        />
                        <Column
                            field="Remarks"
                            header={columnHeader("", "Remarks", "")}
                            editor={(options) => textEditor(options, "Remarks")}
                        />
                    </DataTable>
                </div>
            </div>

        </div>
        }
        </>
    )

}

export default BackofficeAdvice;
                      